var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Order confirmation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(6.000000, 22.438477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2746393,34.5866163 L13.0598981,34.5866163 C11.369758,34.5866163 9.999898,33.2157363 9.999898,31.5266162 L9.999898,7.02213552 C9.999898,5.33097548 11.369758,3.96213544 13.0598981,3.96213544 L55.2746393,3.96213544 C56.9647793,3.96213544 58.3346394,5.33097548 58.3346394,7.02213552 L58.3346394,31.5266162 C58.3346394,33.2157363 56.9647793,34.5866163 55.2746393,34.5866163 Z",
    id: "Stroke-1",
    stroke: "#000000",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3077033,5.03201347 L36.8832228,23.140074 C35.5184627,24.350814 33.4652027,24.348774 32.1035026,23.138034 L11.302642,4.65359346",
    id: "Stroke-3",
    stroke: "#000000",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.9084465,
    y1: 19.3761719,
    x2: 11.302846,
    y2: 33.1747323,
    id: "Stroke-5",
    stroke: "#000000",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.9082713,
    y1: 32.8971902,
    x2: 40.7433109,
    y2: 19.5147899,
    id: "Stroke-7",
    stroke: "#000000",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "#FFFFFF",
    points: "11.302846 6.28088379 5.28369141 -2.80697376e-17 5.28369141 29 13.9228516 29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 11.561523)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7.75904658e-17,
    y1: 6.04531541,
    x2: 15.020934,
    y2: 6.1203181,
    id: "Line",
    transform: "translate(7.729469, 5.870309) scale(-1, 1) translate(-7.729469, -5.870309) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    transform: "translate(13.350609, 6.000000) scale(-1, 1) translate(-13.350609, -6.000000) ",
    points: "16 0 10.7012184 6.00031407 16 12"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.0733f26537939f61ffaae357e190ada3.svg";
export { ForwardRef as ReactComponent };